import base64 from "base-64";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { generateOTP, loginSagaAction, resetPassword, saveAuthKey, validateOTP } from "../../Store/SagaActions/AuthSagaActions";
import LoaderComp from "../../components/LoaderComp/LoaderComp";
import {
  minOrMaxLength,
  validateIsNumAndAlp,
  validateIsRequired,
} from "../../utils/validations";
import { createCaptcha, validateCaptcha } from "./Captcha";
import ForgotPassword from "./ForgotPassword";
import { pathName } from "../../utils/Path";
import { EyeCloseSvg, EyeSvg, RefreshSvg } from "../../assets/svgs/Svg";

const Login = () => {
  const [code, setCode] = useState("");
  const [options, setOptions] = useState([]);
  const [validusername, setvalidusername] = useState(false);

  const [dropdownValue, setDropdownValue] = useState("");
  const dispatch = useDispatch();
  const userObj = {
    username: "",
    password: "",
  };

  const [changePwdErrors, setChangePwdErrors] = useState({
    password: "",
  });

  useEffect(() => {
    createCaptcha();
  }, []);

  const [loginObj, setLoginObj] = useState(userObj);
  // const [usernm,setUsernm]=useState(false)
  // const [pass,setPass]=useState(false)
  const [dpvalue, setDpvalue] = useState(false);
  const [validatedCustom, setValidatedCustom] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false)
  const [forgotPasswordFormData, setForgotPasswordFormData] = useState({})
  const [showOTPField, setShowOTPField] = useState(false)
  const [showNewPasswordField, setShowNewPasswordField] = useState(false)
  const [callingAPItype, setCallingAPIType] = useState("Send otp")
  const [resetPasswordKey, setResetPasswordKey] = useState({})

  // useEffect(() => {
  //   setLoader(true);
  //   dispatch(actionGetDepartmentDetails({ callback: getDeparmentsdata }));
  // }, []);

  const [btndisabled, setbtndisabled] = useState(true);

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    if (value) {
      const isMin = minOrMaxLength(value, "minlength", 8);
      const alpha = validateIsNumAndAlp(value);
      setChangePwdErrors((prevState) => ({
        ...prevState,
        [name]: isMin || alpha,
      }));
    } else {
      const isEmpty = validateIsRequired(value);
      setChangePwdErrors((prevState) => ({ ...prevState, [name]: isEmpty }));
    }

    setLoginObj({ ...loginObj, [name]: value });

    if (checkvalid()) {
      setbtndisabled((prev) => false);
    } else {
      setbtndisabled((prev) => true);
    }
  };

  const checkvalid = () => {
    const isMin = minOrMaxLength(loginObj.password, "minlength", 8);
    const alpha1 = validateIsNumAndAlp(loginObj.password);
    if (isMin && alpha1) return true;
    return false;
  };

  const getDeparmentsdata = (data) => {
    let updatedList =
      data?.length > 0
        ? data?.map((item) => ({ value: item?.deptid, label: item?.deptname }))
        : [];
    setOptions(updatedList);
    setLoader(false);
  };

  const refreshCaptcha = () => {
    setCode("");
    createCaptcha();
  };

  function labels(departmentCode) {
    let type = dashboardType(departmentCode);
    switch (type) {
      case "1":
        return {
          superviser: "Staff",
          worker: "Students",
          institute: "College",
          class: "Course",
          district: "District",
        };
      case "2":
        return {
          superviser: "Supervisors",
          worker: "Workers",
          institute: "Zones",
          class: "Ward",
          district: "District",
        };
      default:
        return {
          superviser: "Staffs",
          worker: "Students",
          institute: "Colleges",
          class: "Courses",
          district: "District"
        };
    }
  }

  function dashboardType(departmentCode) {
    if (["OU", "TE"].includes(departmentCode)) return "1";
    if (["TMC"].includes(departmentCode)) return "2";
    return "1";
  }

  const movetodashboardpage = (e) => {
    // pass the variables based on API RESPONSE

    localStorage.setItem(
      "studentStaffLS",
      JSON.stringify({ value: "1", label: " Students" })
    );
    localStorage.setItem(
      "enrollAttdLS",
      JSON.stringify({ value: "2", label: " Enrollment" })
    );
    localStorage.setItem(
      "rdate",
      JSON.stringify(moment(new Date()).format("YYYY-MM-DD"))
    );
    localStorage.setItem("deptid", dropdownValue?.toString());

    const form = e.target;
    e.preventDefault();
    // if (dropdownValue == "") {
    //   toast.error("Please select the require department");
    //   return;
    // }
    if (code) {
      const result = validateCaptcha(code);
      if (result) {
        const encodePwd = base64.encode(loginObj?.password);
        const model = {
          username: loginObj.username,
          password: encodePwd,
          // departmentId: dropdownValue?.toString(),
        };

        dispatch(
          loginSagaAction({
            model,
            callback: (data) => loginRespData(data, dropdownValue?.toString()),
          })
        );
      } else {
        toast.error("Invalid Captcha!!");
        refreshCaptcha();
        setCode("");
      }
    } else {
      toast.error("Please Enter Captcha!!");
    }
  };

  const loginRespData = (data, departmentId) => {
    sessionStorage.setItem("authkey", JSON.stringify(data));
    dispatch(saveAuthKey(data))

    if (data?.authToken) {
      // toast.success("Login Success");
      sessionStorage.setItem("loginDepartmentId", JSON.stringify(departmentId));
      sessionStorage.setItem("labels", JSON.stringify(labels(data?.deparmentCode)));
      navigate(pathName.dashboard);
    } else {
      toast.error("Invalid Username or Password");
    }
  };


  const handleDropdown = (e) => {
    setDropdownValue(e.value);
  };
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //password validation

  useEffect(() => {
    let getItem = sessionStorage.getItem("openModal")
    if (getItem) setIsOpenModal(true);
  }, [])

  const handleLogout = () => {
    sessionStorage.clear();
    setIsOpenModal(false);
  };


  const callingPasswordForgotAPI = (e) => {
    e.preventDefault();
    let model = forgotPasswordFormData
    switch (callingAPItype) {
      case "Send otp":
        if (code) {
          const result = validateCaptcha(code);
          if (result) {
            dispatch(
              generateOTP({
                model,
                callback: (data) => {
                  if (data?.responsecode === "200") {
                    toast.success(data?.responsedesc)
                    setShowOTPField(true)
                    setCallingAPIType("Validate otp")
                    return
                  }
                  if (data?.responsecode === "300") {
                    toast.error(data?.responsedesc)
                    return
                  }
                  else {
                    toast.error("Try again")
                  }
                }
              })
            );
          } else {
            toast.error("Invalid Captcha!!");
            refreshCaptcha();
            setCode("");
          }
        }
        break;
      case "Validate otp":
        dispatch(
          validateOTP({
            model,
            callback: (data) => {
              if (data?.responsecode === "200") {
                toast.success(data?.responsedesc)
                setResetPasswordKey(data?.resetKey)
                setShowOTPField(false)
                setShowNewPasswordField(true)
                setCallingAPIType("Reset password")
                setForgotPasswordFormData({})
                return
              }
              if (data?.responsecode === "300") {
                toast.error(data?.responsedesc)
                setShowOTPField(false)
                setForgotPasswordFormData({ ...forgotPasswordFormData, otp: "" })
                setCallingAPIType("Send otp")
                return
              }
              else {
                toast.error("Try again")
              }
            }
          })
        );
        break;
      case "Reset password":
        if (model?.newpassword === model?.confirmpassword) {
          model = {
            "resetkey": model?.resetkey,
            "newpassword": base64.encode(model?.newpassword)
          }
          dispatch(
            resetPassword({
              model,
              callback: (data) => {
                if (data?.responsecode === "200") {
                  toast.success(data?.responsedesc)
                }
                if (data?.responsecode === "300") {
                  toast.error(data?.responsedesc)
                }
                setShowOTPField(false)
                setShowNewPasswordField(false)
                setCallingAPIType("Send otp")
                setForgotPasswordFormData({})
                setForgotPasswordModal(false)
              }
            })
          );
        }
        else {
          toast.error("Password does not match")
        }
        break;
      default:
        return
    }

  }
  const handleChange = (e) => {
    const { name, value } = e.target
    if (callingAPItype === "Reset password") {
      setForgotPasswordFormData({ ...forgotPasswordFormData, [name]: value, resetkey: resetPasswordKey });
    }
    else {
      setForgotPasswordFormData({ ...forgotPasswordFormData, [name]: value });
    }
  }
  const gobackToLogin = () => {
    setForgotPasswordModal(false)
    setCallingAPIType("Send otp")
    setShowOTPField(false)
    setShowNewPasswordField(false)
  }

  useEffect(() => {
    refreshCaptcha()
  }, [forgotPasswordModal])
  return (
    <>
      <Modal
        size="sm center"
        show={isOpenModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <h3 className="text-center pt-4 pb-4">Your session has expired</h3>
        <Button className="btn btn-danger-light"
          onClick={handleLogout}>Try login again</Button>
      </Modal>
      {
        forgotPasswordModal ?
          <ForgotPassword
            forgotPasswordModal={forgotPasswordModal}
            gobackToLogin={gobackToLogin}
            code={code}
            setCode={setCode}
            refreshCaptcha={refreshCaptcha}
            handleChange={handleChange}
            forgotPasswordFormData={forgotPasswordFormData}
            callingPasswordForgotAPI={callingPasswordForgotAPI}
            showOTPField={showOTPField}
            showNewPasswordField={showNewPasswordField}
            callingAPItype={callingAPItype}
          />
          :
          <div
            className="page"
            style={{
              backgroundImage: `url("./assets/Images/FrsBackgroundImg.png")`,
              backgroundPosition: "center",
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="page-single">
              <div className="container">
                <Row>
                  <Col
                    xl={5}
                    lg={6}
                    md={8}
                    sm={10}
                    xs={12}
                    className="card-sigin-main mx-auto my-auto py-4 justify-content-center"
                  >
                    <div className="card-sigin">
                      {/* <!-- Demo content--> */}
                      <div className="main-card-signin d-md-flex">
                        <div className="wd-100p">
                          <div className="d-flex mb-3"></div>
                          <div className="">
                            <div className="main-signup-header">
                              <h2 className="text-center">Welcome To Falconfly Dashbaord.</h2>
                              <h6 className="font-weight-bold mb-4 text-center">
                                Please sign in to continue.
                              </h6>
                              <div className="panel panel-primary">
                                <div className=" tab-menu-heading mb-2 border-bottom-0">
                                  <div className="tabs-menu1">
                                    <Form onSubmit={movetodashboardpage}>
                                      <Form.Group className="form-group">
                                        <Form.Label className="">
                                          Username
                                        </Form.Label>{" "}
                                        <Form.Control
                                          className="form-control"
                                          placeholder="Enter Username"
                                          name="username"
                                          type="text"
                                          value={loginObj.username}
                                          onChange={handleUserChange}
                                          required
                                        />
                                      </Form.Group>
                                      <Form.Group className="form-group position-relative">
                                        <Form.Label>Password</Form.Label>{" "}
                                        <div className="hihihihi position-relative">
                                          <Form.Control
                                            className="form-control"
                                            placeholder="Enter password"
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            value={loginObj.password}
                                            onChange={handleUserChange}
                                            minLength="8"
                                            required
                                          />
                                          {/* <i className={showPassword ? 'mg-t-10 bx bx-show eyeIcon' : 'mg-t-10 bx bx-low-vision eyeIcon'} onClick={handleTogglePasswordVisibility}></i> */}
                                          <div className="position-absolute top-50 end-0 translate-middle-y"
                                            style={{ cursor: "pointer" }}
                                            onClick={handleTogglePasswordVisibility}>
                                            {
                                              showPassword ? <EyeSvg className="" /> : <EyeCloseSvg className="" />
                                            }
                                          </div>
                                        </div>
                                        <p className="text-danger">
                                          {changePwdErrors?.password}
                                        </p>
                                      </Form.Group>
                                      <Form.Group className="form-group">
                                        <Row className="row">
                                          <Col sm={12}>
                                            <Row className="row-lg d-flex align-items-center">
                                              <Col
                                                lg={3}
                                                className="d-flex align-items-center me-2"
                                              >
                                                <div
                                                  id="captcha"
                                                  className="d-inline-block me-1"
                                                ></div>
                                                <div
                                                  onClick={refreshCaptcha}
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <RefreshSvg
                                                    className="fe fe-refresh-ccw "
                                                    title="fe fe-refresh-ccw"
                                                  />
                                                </div>
                                              </Col>
                                              <Col className="mg-t-10 mg-sm-t-0 w-100 ">
                                                <Form.Control
                                                  className="form-control"
                                                  placeholder="Enter Captcha"
                                                  name="text"
                                                  type="text"
                                                  value={code}
                                                  autoComplete="off"
                                                  onChange={(e) =>
                                                    setCode(e.target.value)
                                                  }
                                                  required
                                                />
                                              </Col>
                                            </Row>
                                          </Col>
                                        </Row>
                                      </Form.Group>

                                      <Button
                                        variant=""
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={btndisabled}
                                      // onClick={movetodashboardpage}
                                      >
                                        Sign In
                                      </Button>

                                      <div className="main-signin-footer text-center">
                                        <Form.Label className="" role="button" onClick={() => setForgotPasswordModal(true)}>
                                          Forgot password?
                                        </Form.Label>{" "}
                                      </div>
                                    </Form>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
      }

      {loader && (
        <div className="text-center main-loader">
          <img
            src="/assets/Images/final_loader.gif"
            style={{ maxWidth: "200px" }}
          />
        </div>
      )}
      <LoaderComp />


    </>
  );
};

export default Login;
